<template>
    <div>
        <!-- Series ID Nav -->
        <div class="w-50" v-if="adoptionSeries.length > 1">
            <label class="d-inline">Additional Adoptions (Listed by PO Number):  </label>
            <b-select class="d-inline w-75" :value="seriesId" @input="resetAdoptionSeries">
                <b-select-option v-for="(series, i) in adoptionSeries" :value="series.series_id" :key="'series_option_'+i">
                    {{series.data.misc.po_number}}
                </b-select-option>
            </b-select>
        </div>

        <!-- Customer Display -->
        <div class="row">
            <div class="col-8">
                <h3 class="my-0">
                    <!--                            {{customerInfo.adoption_type}}-->
                    <template v-if="customerInfo.adoption_type === 'SS'">Social Studies</template>
                    <template v-if="customerInfo.adoption_type === 'SCI'">Science</template>
                    <template v-if="customerInfo.adoption_type === 'SS|SCI' || customerInfo.adoption_type === 'SCI|SS'">Social Studies & Science</template>
                    Adoption
                </h3>
                <div>
<!--                            <small>{{customerInfo.seriesID}}</small>-->
<!--                            <div class="my-0" v-if="customerInfo.adoption_contract_url"><a :href="customerInfo.adoption_contract_url" target="_blank">Adoption Contract PDF</a></div>-->
                    <div class="">
<!--                                <b-btn variant="link" :to="`/adoption/contact/${customerInfo.customerID}`" target="_blank">Contact Form</b-btn>-->
                    </div>
                    <div class="my-0">
<!--                                <template v-if="customerInfo.startyear == customerInfo.endyear-1">-->
<!--                                    School Year: {{customerInfo.startyear}}-{{customerInfo.startyear+1}}-->
<!--                                </template>-->
                        <template v-if="false">
                            {{customerInfo}}
                            Start Year: {{customerInfo.startyear}}<br/>
                            End Year: {{customerInfo.endyear}}<br/>
                        </template>
                        <template >
                            Start: {{customerInfo.startyear-1}}-{{customerInfo.startyear}}
                            <br/>
                            End: {{customerInfo.endyear-2}}-{{customerInfo.endyear-1}}
                        </template>
                    </div>
                </div>
                <small class="d-none">
                    <p class="mb-0">Customer Id: {{customerInfo.customerID}}</p>
                    <p class="mt-0">Company Id: {{customerInfo.companyID}}</p>
                </small>
                <div>
                    <strong>Billing Address:</strong>
                    <div>
                        {{customerInfo.schoolname}}
                        <br/>
                        {{customerInfo.billingaddress}}
                        <br/>
                        {{customerInfo.billingcity}} {{customerInfo.billingstate}} {{customerInfo.billingzip}}
                    </div>
<!--                            <div class="my-0" v-if="customerInfo.po_number">PO Number: {{customerInfo.po_number}}</div>-->
                </div>

                <div v-if="customerInfo.school_start_date && customerInfo.school_start_date > 0">
                    School Start Date:
                    <b-datepicker
                        class="mt-1"
                        mode="range"
                        color="purple"
                        v-model="startDate"
                        :readonly="true"
                        is-inline
                    />
                </div>

                <div v-if="adoptionData.blackouts.length && blackoutDates.length">
                    "Do not ship" windows
                    <div v-for="(window, i) in blackoutDates">
                        <b-input-group
                            class="mt-1 w-75 date-label"
                            @click="toggleWindow(i)"
                        >
                            <template #prepend>
                                <b-input-group-text class="m-0"><font-awesome-icon :icon="['fas','calendar-times']"></font-awesome-icon></b-input-group-text>
                            </template>
                            <b-form-input
                                type="text"
                                class="date-label m-0"
                                :value="dateRangeText(adoptionData.blackouts[i])"

                                readonly
                            ></b-form-input>

                        </b-input-group>
                        <v-date-picker
                            class="mt-1"
                            mode="range"
                            style="display: none"
                            color="purple"
                            :value="window"
                            :min-date="window.start"
                            :max-date="window.end"
                            :columns="$screens({ default: 1, lg: 2 })"
                            :rows="$screens({ default: 2, lg: 1 })"
                            show-caps
                            is-inline
                            is-double-paned
                            :ref="`blackoutWindow_${i}`"
                            readonly
                        />
                    </div>
                </div>

                <b-btn variant="info"
                       target="_blank"
                       :to="{path:`/adoption/contact/${customerInfo.customerID}/${customerInfo.companyID}`, params: {customerId: customerInfo.customerID, companyId: customerInfo.companyID}}"
                >
                    Review Your Key Contacts
                </b-btn>
                <b-btn variant="warning" class="ml-3"
                       :to="{path:`/adoption/${customerInfo.customerID}/update`}"
                       target="_blank">
                    Submit Updated Numbers
                </b-btn>

            </div>
            <div class="col-4">
                <div>
                    <h5 class="my-0">Adoption Agent</h5>
                    <div>
                        <div class="my-0" v-if="studiesWContact.name">
                            {{studiesWContact.name}}
                        </div>
                        <div class="my-0" v-if="studiesWContact.email">
                            {{studiesWContact.email}}
                        </div>
                        <div class="my-0" v-if="studiesWContact.phone">
                            Phone: {{studiesWContact.phone}} <span v-if="studiesWContact.extension">ext. {{studiesWContact.extension}}</span>
                        </div>
                        <div class="my-0" v-if="studiesWContact.fax">
                            Fax: {{studiesWContact.fax}}
                        </div>
                    </div>
                </div>
                <div v-for="(owner, i) in owners">
                    <h5>{{owner.title || owner.type || owner.hash_key}}</h5>
                    <div>
                        <div class="my-0">{{owner.name}}</div>
                        <div class="my-0">{{owner.email}}</div>
                        <div class="my-0">{{owner.phone}}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quantities Table -->
        <b-row class="mt-3">
            <b-col cols="9">
                <h3>Product Breakdown</h3>
            </b-col>
            <b-col cols="3">

            </b-col>
<!--                    <b-col><b-btn class="float-right" variant="outline-danger" :to="{path:`/adoption/contact/${customerInfo.customerID}/${customerInfo.companyID}`, params: {customerId: customerInfo.customerID, companyId: customerInfo.companyID}}" target="_blank">Submit your updated numbers</b-btn></b-col>-->
            <b-table v-if="quantityTableData" striped :items="quantityTableData" :fields="gradeFields">
                <template #cell(sku)="data">
                    {{data.item.sku}}<template v-if="data.item.subject_override">*</template>
                </template>
            </b-table>
            <small v-if="hasSubjectOverride">*Additional product was provided through your existing Adoption quantities</small>
        </b-row>

        <!-- Invoice Table -->
        <div class="row my-4">
            <div class="text-center w-100 m-0 p-2" style="border: 1px solid #dee2e6">
                <strong>Purchase Order: {{customerInfo.po_number}}</strong>
            </div>

            <!-- ForEach Category/Subject Tables -->
            <template v-for="(tableKey, i) in yearTableKeys">
                <b-table v-if="yearTableData[tableKey]" bordered :items="yearTableData[tableKey]" :fields="yearTableFields" striped>
                    <template #thead-top="data">
                        <b-tr v-if="customerInfo.billed_each_year == 1">
                            <b-th colspan="3" class="text-center">{{tableKey}}</b-th>
                        </b-tr>
                        <b-tr v-if="customerInfo.billed_each_year != 1">
                            <b-th colspan="2" class="text-right">{{tableKey}} Beginning Quantity:</b-th>
                            <b-th colspan="1">{{adoptionData.qtys[tableKey].beginning_qty}}</b-th>
                        </b-tr>
                    </template>
                    <template #cell(invoice_info)="data">
                        {{data.item.invoices.join(", ")}}
                    </template>
                    <template #cell(school_year)="data">
                        {{data.item.year}}
                    </template>
                    <template #cell(quantity)="data">
                        {{data.item.quantity}}
                    </template>
                    <template #custom-foot  v-if="customerInfo.billed_each_year != 1">
                        <b-tr>
                            <b-th colspan="2" class="text-right">Remaining Quantity:</b-th>
                            <b-th colspan="1">{{adoptionData.qtys[tableKey].remaining_qty}}</b-th>
                        </b-tr>
                    </template>
                </b-table>
            </template>
        </div>

        <div class="mb-3">
            <p><span class="text-warning">Disclaimer</span>: Print Teacher Editions are supplied only in the first year of multi-year print orders. Digital access remains available throughout the contract. Additional or replacement print TEs may be purchased by contacting adoptionsupport@studiesweekly.com. </p>
        </div>
        <br/>
        <br/>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import AdoptionNavbar from "@/components/adoptions/AdoptionNavbar";
import UpdateAdoption from "@/views/adoptions/UpdateAdoption";
import {mapState} from 'vuex'
import AdoptionBreadcrumb from "@/components/adoptions/AdoptionBreadcrumb";

export default {
    name: "AdoptionStatus",
    components: {AdoptionBreadcrumb, UpdateAdoption, AdoptionNavbar, Navbar, Calendar, DatePicker},

    props: ['customerId'],
    computed: {
        debug() {
            return this.$route.query.debug == 1;
        },
        ...mapState({
            seriesId: state => state.adoption.seriesId,
            adoptionData: state => state.adoption.adoptionData.data,
            adoptionSeries: state => state.adoption.series,
            contacts: state => state.adoption.contacts,
        }),
        blackoutDates() {
            let dates = this.adoptionData.blackouts.map((i) => ({
                start: new Date(i.start_date*1000),
                end: new Date(i.end_date*1000)
            }));
            console.log(dates);
            return dates;
        },
        owners() {
            let items = [];
            let data = this.adoptionData.misc.owner;
            let keys = Object.keys(data);
            for (let i = 0; i < keys.length; ++i) {

                // Remove Invoice Managers
                if (keys[i] == "Invoice Manager")
                    continue;

                // Check duplicates
                let name = data[keys[i]].name;
                let email = data[keys[i]].email;
                if (this.agentDuplicates[name] || this.agentDuplicates[email]) {
                    continue;
                }

                // Reformat data array
                let key = keys[i];
                data[key]['type'] = key;
                items.push(data[key]);

                // Push keys to duplicate check object.
                this.agentDuplicates[name] = 1;
                this.agentDuplicates[email] = 1;
            }
            return items;
        },
        customerInfo() {
            this.adoptionData.misc.startyear = parseInt(this.adoptionData.misc.startyear);
            this.adoptionData.misc.endyear = parseInt(this.adoptionData.misc.endyear);
            return this.adoptionData.misc;
        },
        studiesWContact() {
            return this.customerInfo.studiesw_contact;
        },
        quantityTableData() {
            // Prepare data for bootstrap table
            let items = [];
            let data = this.adoptionData.grades;
            let grades = Object.keys(data);

            for (let i = 0; i < grades.length; ++i) {
                let grade = grades[i];
                let skus = Object.keys(data[grade]);

                for (let j = 0; j < skus.length; ++j) {
                    let sku = skus[j];
                    let item = data[grade][sku];
                    item['grade'] = grade;
                    item['sku'] = sku;

                    if (item['subject_override']) {
                        this.hasSubjectOverride = true;
                    }

                    if (!this.customerInfo.grades_only) {
                        let sectionData = this.adoptionData.sections.find((section) => {
                            // console.log(section);
                            // Check each box.
                            // for (var grade in section) {
                            // If grade not in this box
                            if (!section.hasOwnProperty(grade))
                                return false;

                            // If sku not in this box
                            return (section[grade].hasOwnProperty(sku))

                            // }
                        });
                        // console.log(sectionData);
                        item['subject'] = sectionData[grade][sku].productfamily;
                    }
                    items.push(item);
                }
            }
            // console.log(items);
            items.sort((a, b) => this.getGradeValue(a.grade) - this.getGradeValue(b.grade));
            return items;
        },
        yearTableKeys() {
            let keys = Object.keys(this.adoptionData.sections_shipped).sort((a,b) => {
                let aScore = a == "Social Studies" ? 2 : (a == "Science" ? 1 : 0);
                let bScore = b == "Social Studies" ? 2 : (b == "Science" ? 1 : 0);
                return bScore - aScore;
            });
            console.log(keys);
            return keys;
        },
        yearTableData() {
            /* Need to format shipped data to the following...
            items [
                Social Studies {
                    2023: {
                        invoice(s): [1234, 576]
                        year: 2023,
                        qty: 1+5
                    },
                    2024: {
                        invoice(s): [4321]
                        year: 2024,
                        qty: 2
                    },
                },
                Science {
                    2023: {
                        invoice(s): [1234, 576]
                        year: 2023,
                        qty: 1+5
                    },
                    2024: {
                        invoice(s): [4321]
                        year: 2024,
                        qty: 2
                    },
                }

            ]
             */
            let items = {};
            let keys = Object.keys(this.adoptionData.shipped);

            for (let i = 0; i < keys.length; ++i) {
                let records = this.adoptionData.shipped[keys[i]];
                for (let j = 0; j < records.length; ++j) {
                    let record = records[j];

                    // Category has Year
                    if (!items.hasOwnProperty(record.hash_key_array)) {
                        items[record.hash_key_array] = {};
                    }

                    // Category Year has invoice Data
                    if (!items[record.hash_key_array].hasOwnProperty(record.year)) {
                        items[record.hash_key_array][record.year] = {
                            invoices: [],
                            year: 0,
                            quantity: 0
                        };
                    }

                    // Push data
                    items[record.hash_key_array][record.year].invoices.push(record.ID);
                    items[record.hash_key_array][record.year].year = record.year;
                    items[record.hash_key_array][record.year].quantity += parseInt(record.shipped_qty);
                }

                // TODO: need to combine year data (years may have multiple invoices)
                // items.push(this.adoptionData.shipped[keys[i]][0]);
            }
            let tableItems = {};
            let tableKeys = Object.keys(items);
            for (let i = 0; i < tableKeys.length; ++i) {
                let yearKeys = Object.keys(items[tableKeys[i]]);

                tableItems[tableKeys[i]] = [];
                for (let j = 0; j < yearKeys.length; ++j) {
                    tableItems[tableKeys[i]].push(items[tableKeys[i]][yearKeys[j]]);
                }
            }
            console.log(items);
            return tableItems;
        },
        schoolStartDate() {
            var date = new Date(parseInt(this.customerInfo.school_start_date) * 1000);
            date.setFullYear(new Date().getFullYear());
            return date;
        },
        gradeFields() {
            // TODO: billed_each_year
            // Remove some fields
            if (this.customerInfo.grades_only) {
                return ['grade', {
                    key: 'qty',
                    label: 'Quantity'
                }, 'teachers']
            }

            // Show all fields
            let fields = ['grade', 'sku'];

            // if (this.customerInfo.adoption_type === 'SS|SCI' || this.customerInfo.adoption_type === 'SCI|SS')
            if (!this.customerInfo.grades_only)
                fields.push('subject');

            fields.push({
                key: 'qty',
                label: 'Quantity'
            })
            fields.push('teachers');
            return fields;
        },
        yearTableFields() {
            if (this.customerInfo.billed_each_year != 1) {
                return ['invoice_info','school_year','quantity'];
            }
            return ['invoice_info','school_year',{key: 'quantity', label: 'Billed Yearly'}]

        }
    },
    data: () => ({
        loadError: "",
        isLoadingAdoption: false,
        items: [],
        agentDuplicates: {},
        childrenData: null,
        startDate: null,
        hasSubjectOverride: false,
    }),
    methods: {
        getGradeValue(grade) {
            if (grade === 'Kindergarten')
                return 0;
            return parseInt(grade.replace(/(Grade )/, ""));
        },
        resetAdoptionSeries(seriesId) {
            if (!seriesId)
                return;

            console.log("Setting series ID:", seriesId);
            this.$store.commit('setAdoptionSeries', seriesId);
            // let adoptionSeries = this.adoptionSeries.filter((series) => series.series_id === id);
            // this.adoptionData = adoptionSeries[0].data;

            // Reset agent duplicates and auto fill it with the contact name/email.
            this.agentDuplicates = {
                [this.adoptionData.misc.studiesw_contact.name]: 1,
                [this.adoptionData.misc.studiesw_contact.email]: 1
            };
        },
        dateRangeText(dateRange) {
            if (!dateRange || !dateRange.end_date)
                return null;

            let startDate = new Date(dateRange.start_date * 1000).toLocaleDateString('en-US');
            let endDate = new Date(dateRange.end_date * 1000).toLocaleDateString('en-US');

            return `${startDate} ~ ${endDate}`;
        },
        toggleWindow(i) {
            let el =  this.$refs[`blackoutWindow_${i}`][0].$el;
            if (el.style.display !== 'none') {
                el.style = 'display: none';
                return;
            }
            el.style = 'display: block';
        },
        updateHeader() {
            this.$route.meta.header = `Adoption Status for ${this.adoptionData.misc.schoolname}`;
            this.$forceUpdate();
        }
    },
    mounted() {
        this.$bvModal.show('updatedNumbersModal');
    },
    created() {
        console.log('adoption: ', this.adoptionData);
        this.resetAdoptionSeries();
        this.startDate = this.schoolStartDate;
        this.updateHeader();
    }
}
</script>

<style scoped>
.container div div {
    margin-bottom: 15px;
}
</style>

<style lang="scss">
@import "@/assets/scss/_colors.scss";

.date-label:hover {
    cursor: pointer !important;
    border: 1px solid deepskyblue;
}
.input-group-prepend {
    margin-bottom: 0 !important;
}
</style>